/**
 * Service pour interroger l'API Elloha (disponibilités, prix à partir de).
 * Doc : https://doc.elloha.com/api/v1/fr/
 */

const ELLOHA_AVAILABILITIES_URL = "https://api.elloha.com/Availabilities";

/** Réponse produit simplifiée (recherche globale) */
interface EllohaProductResponse {
  IdProduct?: string;
  PriceFrom?: number;
  [key: string]: unknown;
}

function formatDateYyyyMmDd(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/**
 * Récupère les prix minimum (PriceFrom) pour plusieurs produits en une requête.
 * Retourne une Map idProduct -> PriceFrom (uniquement les produits avec un prix).
 */
export async function getPriceFromBatch(
  idBookingEngine: string,
  idProducts: string[],
  culture: string,
  ellohaClientId?: string,
): Promise<Map<string, number>> {
  if (idProducts.length === 0) return new Map();

  // Références pour tsc (noUnusedLocals/noUnusedParameters) — code commenté en attente du proxy.
  void idBookingEngine;
  void culture;
  void ellohaClientId;
  if (false as boolean) {
    void ELLOHA_AVAILABILITIES_URL;
    void formatDateYyyyMmDd(new Date());
    const _: EllohaProductResponse = {} as EllohaProductResponse;
    void _;
  }

  // TODO: on appelera un WS proxy côté SIT qui se chargera d'appeler l'API Elloha, au lieu de l'appeler directement côté front ; cela permettra de régler le problème CORS ici, et de positionner le header elloha-client-id côté back
  /*
  const startDate = formatDateYyyyMmDd(new Date());
  const body = {
    IdBookingEngine: idBookingEngine,
    IdProducts: idProducts,
    StartDate: startDate,
  };

  const headers: Record<string, string> = {
    accept: "application/json",
    "Content-Type": "application/json",
    culture,
  };
  if (ellohaClientId) {
    headers["elloha-client-id"] = ellohaClientId;
  }

  try {
    const res = await fetch(ELLOHA_AVAILABILITIES_URL, {
      method: "POST",
      headers,
      body: JSON.stringify(body),
    });

    if (!res.ok) return new Map();

    const data = await res.json();
    if (data?.ErrorCode || !Array.isArray(data)) return new Map();

    const map = new Map<string, number>();
    for (const p of data as EllohaProductResponse[]) {
      const id = p?.IdProduct;
      const price = p?.PriceFrom;
      if (id && typeof price === "number" && Number.isFinite(price)) {
        map.set(id, price);
      }
    }
    return map;
  } catch {
    return new Map();
  }
  */
  return new Map();
}
